import Airtable from "airtable"

const base = new Airtable({apiKey: 'keyogwD6vVcXyASVC'}).base('app9zfPCWF8CLuGyG');

export default base;
